import { toast } from "react-toastify";
import api from "../../services/api";
import type {
  IEditGroupImage,
  IEditGroupResponse,
  IGroup,
  IListGroupsParams,
  IListGroupsResponse,
} from "./types";

export function createGroupUtils() {
  return {
    async getGroups(params: IListGroupsParams) {
      try {
        const response = await api.get<IListGroupsResponse>(
          "list/procedencia/groups",
          { params },
        );
        return response.data;
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
      }
    },

    async getGroupById(groupId: string) {
      const response = await api.get("list/procedencia/groups");
      return response.data.Grupos.filter(
        (group: any) => group.id === parseInt(groupId),
      );
    },

    async editGroup(group_id: number, data: Partial<IGroup>) {
      try {
        const response = await api.put<IEditGroupResponse>(
          `edit/group/${group_id}`,
          data,
        );
        if (response?.data?.msg) {
          toast.success(response?.data?.msg);
        }
        return response;
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      }
    },

    async editGroupImage(data: FormData) {
      try {
        const response = await api.post<IEditGroupImage>(
          `/upload/group/image`,
          data,
        );
        toast.success(response.data.message);

        return response;
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      }
    },
  };
}
